module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    class: _vm.classes,
    on: {
      "mouseenter": _vm.handleMouseenter,
      "mouseleave": _vm.handleMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-rel'],
    on: {
      "click": _vm.handleClick,
      "mousedown": function($event) {
        _vm.handleFocus(false)
      },
      "mouseup": function($event) {
        _vm.handleBlur(false)
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    ref: "popper",
    class: [_vm.prefixCls + '-popper'],
    style: (_vm.styles)
  }, [_c('div', {
    class: [_vm.prefixCls + '-content']
  }, [_c('div', {
    class: [_vm.prefixCls + '-arrow']
  }), _vm._v(" "), (_vm.confirm) ? _c('div', {
    class: [_vm.prefixCls + '-inner']
  }, [_c('div', {
    class: [_vm.prefixCls + '-body']
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-help-circled"
  }), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-body-message']
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)]), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-footer']
  }, [_c('i-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeCancelText))]), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    nativeOn: {
      "click": function($event) {
        _vm.ok($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeOkText))])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.confirm) ? _c('div', {
    class: [_vm.prefixCls + '-inner']
  }, [(_vm.showTitle) ? _c('div', {
    ref: "title",
    class: [_vm.prefixCls + '-title']
  }, [_vm._t("title", [_c('div', {
    class: [_vm.prefixCls + '-title-inner']
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-body']
  }, [_c('div', {
    class: [_vm.prefixCls + '-body-content']
  }, [_vm._t("content", [_c('div', {
    class: [_vm.prefixCls + '-body-content-inner']
  }, [_vm._v(_vm._s(_vm.content))])])], 2)])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c84a82aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/poptip/poptip.vue
// module id = 669
// module chunks = 1